import React, { createContext, useContext } from 'react';
// You'll want to define a proper 'System' and 'Config' type in a shared file
// For now, we'll use 'any' as a placeholder.
type SystemData = any; 
type Config = any;

export type SystemSection =
  | "clientProcess"
  | "assetProcessing"
  | "assetStorage"
  | "assetSyndication"
  | "systemInfo"
  | "createSystem";

interface ISystemsContext {
  // State
  formData: SystemData;
  configs: Config[];
  selectedSection: SystemSection;
  expandedConfigId: string | null;
  dirty: boolean;
  isSaving: boolean;
  isLoadingSystem: boolean;
  canSave: boolean;
  
  // Actions / Handlers
  handleChange: (key: string, value: any) => void;
  saveChanges: () => void;
  selectSection: (section: SystemSection) => void;
  selectConfig: (configId: string | null) => void;
  selectSystemInfo: () => void;
  
  // System CRUD
  createNewSystem: () => void;
  cancelCreateSystem: () => void;
  deleteCurrentSystem: () => void;

  // Config CRUD
  createNewConfig: () => void;
  deleteSelectedConfig: () => void;
  duplicateSelectedConfig: () => void;
}

export const SystemsContext = createContext<ISystemsContext | undefined>(undefined);

export const useSystemsContext = () => {
  const context = useContext(SystemsContext);
  if (!context) {
    throw new Error('useSystemsContext must be used within a SystemsProvider');
  }
  return context;
};